//import axios from 'axios';




const state={
    devoirs:[
      {
        id: "1", 
        niveau: "1ère année",
        class: "1ère B1",
        matièr:"Mathématique",
        devoirm: "Lorem ipsum dolor sit amet ..",
        pourle:"22/06/22",
        Statut:"Brouillon",
        Creepar:"Hamadi Dhouieb",
        Creele:"Créé le"
      },
      {
        id: "2", 
        niveau: "1ère année",
        class: "1ère B1",
        devoirm: "Lorem ipsum dolor sit amet ..",
        pourle:"22/06/22",
        Statut:"Brouillon",
        Creepar:"Hamadi Dhouieb",
        Creele:"Créé le"
      },
      {
        id: "3", 
        niveau: "1ère année",
        class: "1ère B1",
        devoirm: "Lorem ipsum dolor sit amet ..",
        pourle:"22/06/22",
        Statut:"Active",
        Creepar:"Hamadi Dhouieb",
        Creele:"Créé le"
      },
      {
        id: "4", 
        niveau: "1ère année",
        class: "1ère B1",
        devoirm: "Lorem ipsum dolor sit amet ..",
        pourle:"22/06/22",
        Statut:"Active",
        Creepar:"Hamadi Dhouieb",
        Creele:"Créé le"
      },
      {
        id: "5", 
        niveau: "1ère année",
        class: "1ère B1",
        devoirm: "Lorem ipsum dolor sit amet ..",
        pourle:"22/06/22",
        Statut:"Active",
        Creepar:"Hamadi Dhouieb",
        Creele:"Créé le"
      },
      {
        id: "6", 
        niveau: "1ère année",
        class: "1ère B1",
        devoirm: "Lorem ipsum dolor sit amet ..",
        pourle:"22/06/22",
        Statut:"Active",
        Creepar:"Hamadi Dhouieb",
        Creele:"Créé le"
      },
    
    ]
};

const getters={
    DevoirsPagination:(state)=>(from,to)=>state.devoirs.slice(from,to),
    allDevoirs:(state)=>state.devoirs
};

const actions={

     fetchDvoirs({commit}){
  
        getMessagesData({
            params: {
                  
            }
        })
        .then(response => {
        })
        .catch(error => {
        });

        // const response= await axios.get('https://jsonplaceholder.typicode.com/todos')
    }
};

const mutations={};


export default{
    state,
    getters,
    actions,
    mutations
}



